import { render } from "./ListaTransferenciaExterna.vue?vue&type=template&id=ccd6978e&scoped=true"
import script from "./ListaTransferenciaExterna.vue?vue&type=script&lang=js"
export * from "./ListaTransferenciaExterna.vue?vue&type=script&lang=js"

import "./ListaTransferenciaExterna.vue?vue&type=style&index=0&id=ccd6978e&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccd6978e"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QSelect,QBtn});
